const PUBLIC_PROPOSAL_PATHS = [
  /^\/proposta\//,
  /^\/proposta-simplificada\//,
  /^\/analise-detalhada\//,
  /^\/geracao-distribuida\/proposta\//,
];

export const isPublicProposalPath = (pathname: string): boolean =>
  PUBLIC_PROPOSAL_PATHS.some((re) => re.test(pathname));

type RequestLocation = Pick<Location, 'pathname' | 'search'>;

export const resolveRequestToken = (
  sessionToken: string | undefined,
  location: RequestLocation,
): string | undefined => {
  if (sessionToken) return sessionToken;
  if (!isPublicProposalPath(location.pathname)) return undefined;
  return new URLSearchParams(location.search).get('token') || undefined;
};
